__turbopack_context__.v({
  "kit-details__body": "KitDetailsModal-module-scss-module__Uz0A0G__kit-details__body",
  "kit-details__close": "KitDetailsModal-module-scss-module__Uz0A0G__kit-details__close",
  "kit-details__description": "KitDetailsModal-module-scss-module__Uz0A0G__kit-details__description",
  "kit-details__divider": "KitDetailsModal-module-scss-module__Uz0A0G__kit-details__divider",
  "kit-details__image": "KitDetailsModal-module-scss-module__Uz0A0G__kit-details__image",
  "kit-details__media": "KitDetailsModal-module-scss-module__Uz0A0G__kit-details__media",
  "kit-details__sale-badge": "KitDetailsModal-module-scss-module__Uz0A0G__kit-details__sale-badge",
});
